import UserError from './UserError.js'

export class AdShareByEmailUserError extends UserError {}
